/* eslint-disable */

import Interactions16 from '@carbon/icons-react/es/interactions/16';
import UserFilled16 from '@carbon/icons-react/es/user--filled/16';
import User16 from '@carbon/icons-react/es/user/16';
import { Dropdown, Menu } from 'antd';
import React, { FC, useState } from 'react';
import { Switch } from 'components/atoms/switch/switch';
import { Switcher } from 'components/atoms/switcher';
import { theme } from 'components/styles/theme';

type Size = keyof typeof theme.heights;

const SwitcherDemoComponent: FC<{
  size: Size;
  solid?: boolean;
  icon?: boolean;
}> = ({ size, solid = false, icon = false }) => {
  const [value, setValue] = useState('vendor');
  return (
    <Switcher
      value={value}
      onChange={(e) => setValue(e.target.value)}
      size={size}
      solid={solid}
    >
      <Switcher.Button value="vendor" icon={icon ? <User16 /> : null}>
        Vendor
      </Switcher.Button>
      <Switcher.Button value="customer" icon={icon ? <UserFilled16 /> : null}>
        Customer
      </Switcher.Button>
      <Switcher.Button value="any" icon={icon ? <Interactions16 /> : null}>
        Any
      </Switcher.Button>
    </Switcher>
  );
};

export const SwitcherDemo: FC = () => {
  const [size, setSize] = useState<Size>('medium');
  const [solid, setSolid] = useState(false);
  const [icon, setIcon] = useState(true);
  const sizeMenu = (
    <Menu onClick={(e) => setSize(e.key as Size)}>
      <Menu.Item key="small">Small</Menu.Item>
      <Menu.Item key="medium">Medium</Menu.Item>
      <Menu.Item key="large">Large</Menu.Item>
    </Menu>
  );

  return (
    <>
      <div>
        <h4>Dynamic</h4>
        <Dropdown overlay={sizeMenu}>
          <a style={{ marginRight: 32 }} onClick={(e) => e.preventDefault()}>
            Size: {size}
          </a>
        </Dropdown>
        <strong style={{ marginRight: 8 }}>Solid</strong>
        <Switch
          style={{ marginRight: 32 }}
          checked={solid}
          onChange={setSolid}
        />
        <strong style={{ marginRight: 8 }}>Icon</strong>
        <Switch style={{ marginRight: 32 }} checked={icon} onChange={setIcon} />
        <hr />
        <div>
          <SwitcherDemoComponent size={size} solid={solid} icon={icon} />
        </div>
      </div>
      <hr style={{ marginBottom: 32 }} />
      <h5>Outlines</h5>
      <div>
        <h6>Small</h6>
        <SwitcherDemoComponent size="small" />
      </div>
      <div>
        <h6>Middle</h6>
        <SwitcherDemoComponent size="medium" />
      </div>
      <div>
        <h6>Large</h6>
        <SwitcherDemoComponent size="large" />
      </div>
      <hr style={{ marginBottom: 32 }} />
      <h5>Solids</h5>
      <div>
        <h6>Small Solid</h6>
        <SwitcherDemoComponent size="small" solid />
      </div>
      <div>
        <h6>Middle Solid</h6>
        <SwitcherDemoComponent size="medium" solid />
      </div>
      <div>
        <h6>Large Solid</h6>
        <SwitcherDemoComponent size="large" solid />
      </div>
    </>
  );
};
